import { Skeleton } from "./skeleton";

/**
 * Suspense fallback for lazily-loaded routes.
 *
 * It deliberately mirrors the real public shell: a fixed top bar at the exact
 * nav height (h-14 / md:h-16) plus a top-aligned hero block that clears it.
 * Because the placeholder occupies the same position as the page that replaces
 * it, the swap doesn't recenter or jump the viewport — which is what made cold
 * (uncached) loads feel like everything "hopped around".
 */
export const PageSkeleton = () => (
  <div className="min-h-screen bg-surface">
    {/* Nav placeholder — same fixed position + height as the real <nav>. */}
    <div className="fixed inset-x-0 top-0 z-50 h-14 border-b border-border bg-background md:h-16">
      <div className="container mx-auto flex h-full items-center justify-between px-4">
        <Skeleton className="h-7 w-32" />
        <div className="hidden items-center gap-6 md:flex">
          <Skeleton className="h-4 w-14" />
          <Skeleton className="h-4 w-14" />
          <Skeleton className="h-4 w-14" />
          <Skeleton className="h-9 w-24 rounded-md" />
        </div>
        <Skeleton className="h-9 w-9 rounded-md md:hidden" />
      </div>
    </div>

    {/* Top-aligned hero placeholder, clearing the fixed nav (matches pt-20/24/28). */}
    <div className="container mx-auto px-4 pt-20 md:pt-24 lg:pt-28">
      <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_340px] lg:items-start">
        <div className="space-y-5">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-11 w-4/5 md:h-14" />
          <Skeleton className="h-5 w-full max-w-md" />
          <Skeleton className="h-5 w-2/3 max-w-md" />
          <div className="pt-2">
            <Skeleton className="h-11 w-44 rounded-md" />
          </div>
        </div>
        <Skeleton className="hidden h-80 w-full rounded-lg lg:block" />
      </div>
    </div>
  </div>
);
